
define('ldsh!modules/form_editor/templates/field_editor', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="js-title"></div>\n<div class="js-common"></div>\n<div class="js-field"></div>\n<div class="js-common-advanced"></div>\n<div class="js-field-advanced"></div>\n';

}
return __p
};});

